import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { DriversState } from '../../types';

import { getDriverFuelAssignments } from '../operations/getDriverFuelAssignments';

import { STATUS_LOADING } from 'common/constants';

export const setDriverFuelAssignments = (builder: ActionReducerMapBuilder<DriversState>) => builder
  .addCase(getDriverFuelAssignments.pending, (state) => {
    state.fuelAssignments.loadingStatus = STATUS_LOADING.load;
  })
  .addCase(getDriverFuelAssignments.fulfilled, (state, { payload }) => {
    const { items, ...paging } = payload;
    state.fuelAssignments.loadingStatus = STATUS_LOADING.done;
    state.fuelAssignments.data = items;
    state.fuelAssignments.paging = paging;
  })
  .addCase(getDriverFuelAssignments.rejected, (state) => {
    state.fuelAssignments.loadingStatus = STATUS_LOADING.error;
  });